const _env = process.env.NODE_ENV === 'development' ? process.env : (window as any)._env_;
export const config = {
  environment: _env.REACT_APP_ENVIRONMENT || 'dev',
  appVersion: _env.REACT_APP_VERSION || 'local',
  appName: _env.REACT_APP_NAME || 'truebar-editor',
  commitHash: _env.REACT_APP_COMMIT_HASH || 'tbd',
  backendApiUrl: _env.REACT_APP_BACKEND_URL || 'https://dev-editor-backend.true-bar.si',
  backendWsUrl: _env.REACT_APP_WEBSOCKET_URL || 'wss://dev-editor-backend.true-bar.si/ws',
  keycloakUrl: _env.REACT_APP_KEYCLOAK_URL || 'https://dev-keycloak.vitasis.si',
  keycloakAuthReam: _env.REACT_APP_KEYCLOAK_AUTH_REALM || 'truebar',
  keycloakClientId: _env.REACT_APP_KEYCLOAK_CLIENT_ID || 'truebar-editor',
  monitoringEnabled: _env.REACT_APP_MONITORING_ENABLED,
  monitoringApmServerUrl: _env.REACT_APP_MONITORING_APM_SERVER_URL || 'https://apm.vitasis.si',
  prepareTranscripts: _env.REACT_APP_PREPARED_TRANSCRIPTS,
  publicUrl: _env.REACT_APP_PUBLIC_URL || 'http://localhost:3000',
  keycloakIdpAlias: _env.REACT_APP_KEYCLOAK_IDP_ALIAS || 'idp',
  frameworksIgnoringIterims: (_env.REACT_APP_FRAMEWORKS_IGNORING_INTERIM || '') as string,
  summaryServiceUrl: _env.REACT_APP_SUMMARY_SERVICE_URL || 'https://llm.true-bar.si',
  summaryDefaultModel: _env.REACT_APP_SUMMARY_DEFAULT_MODEL || 'gpt-5',
};
